;( function( $, undefined )
{

    $.fn.SiteCatalystCategory = function( siteCat )
    {
        $( '.actions-row' ).find( '.pdc6-button-blue.add-button' ).on( 'click', function()
        {
            siteCat.track( 'Intent to create a new thread', {
                type   : siteCat.eventType.other,
                vars   : {
                    prop49 : 'button:intent to create a new thread:null:' + siteCat.pageName,
                    eVar49 : 'D=c49'
                },
                events : [ 66 ]
            } );
        } );
    };

} )( jQuery );